import { createSlice } from "@reduxjs/toolkit";
import {
  getTemplateList,
  getSubTemplateList,
  getEvaluationTypeList,
  saveNewTemplate,
  getTemplateDetails,
  updateTemplate,
  deleteTemplate,
  getCategoryList,
} from "../services/manage-template.service";
import { getCategoryObj } from "../core/utils/utils";

const initialState = {
  listLoader: false,
  subListLoader: false,
  saveTemplateLoader: false,
  evaluationTypeLoader: false,
  listData: [],
  evaluationTypeListData: [],
  subListData: [],
  totalListCount: 0,
  subTotalListCount: 0,
  saveNewTemplateMsgSuccess: "",
  deleteTemplateMsgSuccess: "",
  deleteTemplateMsgError:"",
  templateDetailsData: null,
  error: "",
  saveNewTemplateMsgError: "",
  categoryListArray: []
};
const ManageTemplateSlice = createSlice({
  name: "template-list",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTemplateList.pending, (state, action) => {
        state.listLoader = true;
        state.saveNewTemplateMsgSuccess = "";
        state.saveNewTemplateMsgError = "";
        state.deleteTemplateMsgSuccess = "";
        state.deleteTemplateMsgError = "";
        state.templateDetailsData = null;
      })
      .addCase(getTemplateList.fulfilled, (state, action) => {
        state.listLoader = false;
        state.listData = action.payload?.results;
        state.totalListCount = action.payload?.count;
      })
      .addCase(getTemplateList.rejected, (state: any, action) => {
        state.listLoader = false;
        state.error = action.error?.message || "Failed to load employee list"; 
      })      
      .addCase(getCategoryList.fulfilled, (state, action) => {
        state.categoryListArray =  action.payload?.results;
      })
      .addCase(getCategoryList.rejected, (state: any, action) => {
        state.error = action.error?.message || "Failed to load employee list"; 
      })
      .addCase(saveNewTemplate.pending, (state, action) => {
        state.saveTemplateLoader = true;
        state.templateDetailsData = null;
      })
      .addCase(saveNewTemplate.fulfilled, (state, action) => {
        state.saveTemplateLoader = false;
        state.saveNewTemplateMsgSuccess = "Template created successfully";      
      })
      .addCase(saveNewTemplate.rejected, (state: any, action) => {
        state.saveTemplateLoader = false;
        state.saveNewTemplateMsgError = action.error?.message || "Failed to load template list"; 
      })
      .addCase(updateTemplate.pending, (state, action) => {
        state.saveTemplateLoader = true;
      })
      .addCase(updateTemplate.fulfilled, (state, action) => {
        state.saveTemplateLoader = false;
        state.saveNewTemplateMsgSuccess = "Template updated successfully";      
      })
      .addCase(updateTemplate.rejected, (state: any, action) => {
        state.saveTemplateLoader = false;
        state.saveNewTemplateMsgError = action.error?.message || "Failed to load template list"; 
      })
      .addCase(deleteTemplate.pending, (state, action) => {
        state.deleteTemplateMsgSuccess = "";
        state.deleteTemplateMsgError = "";
      })
      .addCase(deleteTemplate.fulfilled, (state, action) => {
        state.deleteTemplateMsgSuccess = "Template deleted successfully";      
      })
      .addCase(deleteTemplate.rejected, (state: any, action) => {
        state.deleteTemplateMsgError = action.error?.message || "Failed to load template list"; 
      })
      .addCase(getTemplateDetails.pending, (state: any, action) => {
        state.saveTemplateLoader = true;
        state.templateDetailData = null;
      })
      .addCase(getTemplateDetails.fulfilled, (state: any, action) => {
        state.saveTemplateLoader = false;
        state.templateDetailsData = action.payload
      })
      .addCase(getTemplateDetails.rejected, (state: any, action) => {
        state.saveTemplateLoader = true;
      })
      .addCase(getSubTemplateList.pending, (state, action) => {
        state.subListLoader = true;
      })
      .addCase(getSubTemplateList.fulfilled, (state, action) => {
        state.subListLoader = false;
        state.subListData = action.payload;
      })
      .addCase(getSubTemplateList.rejected, (state:any, action) => {
        state.subListLoader = false;
        state.error = action.error?.message || "Failed to load evaluation list";
      })
      .addCase(getEvaluationTypeList.pending, (state, action) => {
        state.evaluationTypeLoader = true;
      })
      .addCase(getEvaluationTypeList.fulfilled, (state, action) => {
        state.evaluationTypeLoader = false;
        state.evaluationTypeListData = action.payload;
      })
      .addCase(getEvaluationTypeList.rejected, (state: any, action) => {
        state.evaluationTypeLoader = false;
        state.error = action.error?.message || "Failed to load evaluation list"; 
      })
  },
});

export default ManageTemplateSlice.reducer;
